<div class="admin-dialog" [class.admin-dialog--display-mode]="mode === Mode.disp">
  <div class="admin-dialog__header">
    <div class="admin-dialog__header-left">
      <h2 class="admin-dialog__title" i18n="@@adminSystem.sectionGroupDetails.title.info">セクショングループ情報</h2>
    </div>
    <button mat-icon-button class="admin-dialog__close" (click)="onNoClick()" aria-label="Close dialog" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="admin-dialog__content">
    <form [formGroup]="sectionGroupFormGroup">

      @if (sectionGroupId == null && this.common.hasAllSectionGroupManagement()) {
        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@adminSystem.sectionGroupDetails.label.assignAdmin">管理者割り当て</span>
          </div>
          <mat-radio-group formControlName="assignAdmin" class="form-radio-group">
            @for (aa of assignAdmin; track aa) {
              <mat-radio-button [value]="aa.value" color="primary">{{ aa.desc }}</mat-radio-button>
            }
          </mat-radio-group>
        </div>
      }

      <div class="admin-dialog__section">
        <div class="form-label">
          <span class="form-label__text" i18n="@@adminSystem.sectionGroupDetails.label.name">セクショングループ名</span>
          <span class="form-label__required">*</span>
        </div>
        <mat-form-field appearance="outline" class="form-field">
          <input matInput formControlName="name" />
          <mat-icon matSuffix class="material-icons-outlined">business</mat-icon>
          @if (sectionGroupFormGroup.get('name')?.hasError('required')) {
            <mat-error i18n="@@adminSystem.sectionGroupDetails.error.required">必須項目です</mat-error>
          }
        </mat-form-field>
      </div>

      @if(sectionGroupId != null){
        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@adminSystem.sectionGroupDetails.label.id">ID</span>
          </div>
          <mat-form-field appearance="outline" class="form-field">
            <input matInput formControlName="id" />
            <mat-icon matSuffix class="material-icons-outlined">badge</mat-icon>
          </mat-form-field>
        </div>
      }

      <div class="admin-dialog__divider"></div>

      <app-addresses-form [addressesForm]="getAddressesGroup()"></app-addresses-form>

      <div class="admin-dialog__divider"></div>

      <app-contact-details-form [contactDetailsForm]="getContactDetailsGroup()"></app-contact-details-form>


      <div formGroupName="billingInfo" class="admin-dialog__section">        
        <app-sg-billing-info-form #billingInfoFormComp 
          [sgBillingInfoForm]="getBillingInfoGroup()"
          [sectionGroupData]="sectionGroupData"
        ></app-sg-billing-info-form>

        <!-- <div class="admin-dialog__field-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label i18n="@@adminSystem.sectionGroupDetails.label.contractChannel">契約チャネル</mat-label>
            <mat-select formControlName="contractChannel" (selectionChange)="onContractChannelChanged($event.value)">
              @for (item of sectionGroupContractChannel; track item) {
                <mat-option [value]="item.code">{{ item.desc }}</mat-option>
              }
            </mat-select>
            @if (sectionGroupFormGroup.get('billingInfo.contractChannel')?.hasError('required')) {
              <mat-error i18n="@@adminSystem.sectionGroupDetails.error.required">必須項目です</mat-error>
            }
          </mat-form-field>

          @if (sectionGroupFormGroup.get('billingInfo.contractChannel')?.value == "DISTRIBUTOR"){
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>代理店名</mat-label>
              <input matInput [value]="distributor()?.name" [readonly]="true" />
            </mat-form-field>
          }
        </div>

        @if (sectionGroupFormGroup.get('billingInfo.contractChannel')?.value == "DIRECT") {
          <div class="admin-dialog__divider"></div>

          <app-sg-billing-info-form [billingSourceForm]="getBillingSourceGroup()"></app-sg-billing-info-form>
          
          <div class="admin-dialog__divider"></div>

          <app-billing-source-form [billingSourceForm]="getBillingSourceGroup()"></app-billing-source-form>
          
         <div class="admin-dialog__divider"></div>

          <app-billing-terms-form [billingTermsForm]="getBillingTermsGroup()"></app-billing-terms-form>
        } -->
      </div>

      <div class="admin-dialog__divider"></div>


      <div formGroupName="settings">

        <div formGroupName="assets" class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@adminSystem.sectionGroupDetails.label.logoUrl">ロゴURL</span>
          </div>
          <mat-form-field appearance="outline" class="form-field">
            <input matInput formControlName="logoUrl" />
            <mat-icon matSuffix class="material-icons-outlined">image</mat-icon>
            @if (sectionGroupFormGroup.get('settings.assets.logoUrl')?.hasError('required')) {
              <mat-error i18n="@@adminSystem.sectionGroupDetails.error.required">必須項目です</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@adminSystem.sectionGroupDetails.label.monthlyQuota">一か月のデータ使用料上限</span>
          </div>
          <mat-form-field appearance="outline" class="form-field form-field--date">
            <input matInput formControlName="monthlyQuotaGB" type="number" min="10" max="100" />
            <span matTextSuffix class="form-field__unit-suffix">GB</span>
          </mat-form-field>
        </div>

        <div class="admin-dialog__divider"></div>

        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@adminSystem.sectionGroupDetails.label.userDataSettings">ユーザーデータ設定</span>
          </div>
          <select id="userDataTemplateDropdown"
                  class="legacy-select"
                  [disabled]="mode==Mode.disp"
                  (change)="onUserDataTemplateSelected($event)">
            <option value="" disabled selected i18n="@@adminSystem.sectionGroupDetails.option.selectTemplate">標準テンプレートから選択</option>
            @for (template of userDataTemplatesFiltered; track template.id) {
              <option [value]="template.id">{{template.name}}</option>
            }
          </select>
          <mat-form-field appearance="outline" class="form-field form-field--full">
            <textarea matInput formControlName="userDataAttributes" rows="4" (input)="onUserDataAttributesChanged($event)"></textarea>
            @if (sectionGroupFormGroup.get('settings.userDataAttributes')?.hasError('required')) {
              <mat-error i18n="@@adminSystem.sectionGroupDetails.error.required">必須項目です</mat-error>
            }
          </mat-form-field>
        </div>

      </div> 
      
      @if (mode!=Mode.disp) {
        <div class="admin-dialog__section">
          <div class="form-label form-label--small">
            <span class="form-label__text" i18n="@@adminSystem.sectionGroupDetails.label.errorCheck">ユーザーデータ設定 エラーチェック</span>
          </div>
          <div class="preview-box">
            @for (error of errors; track error; let i = $index) {
              <div class="preview-box__line preview-box__line--error">{{ error }}</div>
            }
          </div>
        </div>
      }

      <div class="admin-dialog__section">
        <div class="form-label form-label--small">
          <span class="form-label__text" i18n="@@adminSystem.sectionGroupDetails.label.preview">ユーザーデータ設定 プレビュー</span>
        </div>
        <div class="preview-box">
          @for (preview of previews; track preview; let i = $index) {
            <div class="preview-box__line">{{ preview }}</div>
          }
        </div>
      </div>

      <div class="admin-dialog__divider"></div>


      <div class="admin-dialog__section">
        <div class="form-label">
          <span class="form-label__text" i18n="@@adminSystem.sectionGroupDetails.label.functions">利用可能な機能</span>
        </div>
        @if (sectionGroupFormGroup.get('billingInfo.contractChannel')?.value == "DISTRIBUTOR"){
          <div class="form-label">
            <span class="form-label__text" i18n="@@adminSystem.sectionGroupDetails.label.alignWithDistributor">代理店の設定に準じます</span>
          </div>
        }
        @else{
          <div class="role-checkboxes">
            <label class="role-checkbox">
              <mat-checkbox [formControl]="allFunctionsControl()" color="primary" (change)="allFunctionsCheckboxClicked()"></mat-checkbox>
              <span class="role-checkbox__label" i18n="@@adminSystem.sectionGroupDetails.label.allFunctions">すべての機能</span>
            </label>
            <div formGroupName="settings">
              <div formGroupName="functionAttributes" class="admin-dialog__section">
                @for (func of common.SectionGroupFunctions; track func.code) {
                  <label class="role-checkbox">
                    <mat-checkbox [formControlName]="func.code" color="primary" (change)="refreshAllFunctionsCheckbox()"></mat-checkbox>
                    <span class="role-checkbox__label">{{ func.desc }}</span>
                  </label>
                }
              </div>
            </div>
          </div>
        }

      </div>


      @if (sectionGroupId != null) {
        <div class="admin-dialog__divider"></div>
        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@adminSystem.sectionGroupDetails.label.admins">管理者</span>
          </div>
          <select multiple id="adminSelect" class="legacy-select legacy-select--multi">
            @for (admin of admins(); track $index) {
              <option [value]="admin.user?.userId">
                {{ admin.user?.lastName }} {{ admin.user?.firstName }}
              </option>
            }
          </select>
          @if (hasSectionGroupAdminManagement || hasAllSectionGroupManagement) {
            <div class="admin-action-row">
              <button mat-stroked-button type="button" (click)="createAdmin()">
                <mat-icon>person_add</mat-icon>
                <span i18n="@@adminSystem.sectionGroupDetails.button.createAdmin">管理者作成</span>
              </button>
              <button mat-stroked-button type="button" (click)="inviteAdmin()">
                <mat-icon>send</mat-icon>
                <span i18n="@@adminSystem.sectionGroupDetails.button.inviteAdmin">管理者招待</span>
              </button>
            </div>
          }
        </div>
      }

    </form>
  </div>

  <div class="admin-dialog__footer">
    @if (!changesMade) {
      <button mat-stroked-button (click)="onNoClick()">
        <span i18n="@@adminSystem.sectionGroupDetails.button.close">閉じる</span>
      </button>
    } @else {
      <button mat-stroked-button color="warn" (click)="onNoClick()">
        <span i18n="@@adminSystem.sectionGroupDetails.button.discard">破棄</span>
      </button>
    }
    @if (canUpdate) {
      <button mat-flat-button color="primary" [disabled]="isSending()" (click)="onEditOrUploadClicked()">
        @if (isSending()) {
          <mat-spinner diameter="18"></mat-spinner>
        }
        <span i18n="@@adminSystem.sectionGroupDetails.button.action">{{ mode === Mode.disp ? '編集' : mode === Mode.create ? '作成' : '保存' }}</span>
      </button>
    }
    @if (sectionGroupId != null && fromSystemAdmin) {
      <button mat-stroked-button (click)="openSectionGroupAdmin()">
        <mat-icon>open_in_new</mat-icon>
        <span i18n="@@adminSystem.sectionGroupDetails.button.adminPage">管理ページ</span>
      </button>
    }
  </div>
</div>
